<h2 class="modal__title modal__title--size-{{ size }}">
  <ng-content></ng-content>
</h2>
